"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _digiwashComponents = require("digiwash-components");

var _styledUtils = require("@sloth-system/styled-utils");

var _native = _interopRequireDefault(require("styled-components/native"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Container = (0, _native.default)(_digiwashComponents.Box)`
  border: 2px solid
    ${props => props.isSelected ? (0, _styledUtils.color)("primary.main") : (0, _styledUtils.color)("neutrals.850")};
  border-radius: ${(0, _styledUtils.radii)("xs")};
`;

function Checkbox(props) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    isSelected: props.selected
  }, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    p: "xs",
    style: {
      width: props.width,
      height: props.height
    }
  }, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    br: "xs",
    bg: props.selected ? "primary.main" : "common.white",
    style: {
      width: "100%",
      height: "100%"
    }
  })));
}

var _default = Checkbox;
exports.default = _default;